import { Link } from 'react-router-dom';
import useDocumentMeta from '@/hooks/useDocumentMeta';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { siteInfo } from '@/mocks/site';

export default function About() {
  useDocumentMeta({
    title: '关于我们 - 51每日大赛',
    description:
      '了解51每日大赛的站点定位、内容服务范围与联系方式。我们专注于每日赛事黑榜、排名数据与赛事资讯的发布，服务全球竞技赛事爱好者。',
    keywords: '关于我们,51每日大赛,网站介绍,联系方式,赛事资讯平台',
  });

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-8 py-8">
      <Breadcrumb items={[{ label: '首页', path: '/' }, { label: '关于我们' }]} />

      <section className="mt-6 rounded-lg overflow-hidden border border-background-200 relative">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20esports%20media%20office%20with%20large%20screens%20showing%20ranking%20dashboards%2C%20deep%20navy%20blue%20lighting%20with%20warm%20orange%20accents%2C%20clean%20professional%20editorial%20atmosphere%2C%20high%20detail%20photography&width=1600&height=600&seq=about-hero&orientation=landscape"
          alt="51每日大赛 团队工作场景"
          title="关于51每日大赛"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-950/85 via-primary-950/60 to-primary-950/30"></div>
        <div className="relative p-8 md:p-14 max-w-2xl">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-500 text-primary-950 text-xs font-bold whitespace-nowrap">
            ABOUT US
          </span>
          <h1 className="mt-4 text-2xl md:text-4xl font-black text-background-50 tracking-tight">
            51每日大赛 · {siteInfo.slogan}
          </h1>
          <p className="mt-4 text-sm md:text-base text-background-200 leading-relaxed">
            {siteInfo.intro}
          </p>
        </div>
      </section>

      <section className="mt-10">
        <h2 className="text-xl md:text-2xl font-black text-foreground-950 tracking-tight">
          我们能提供什么
        </h2>
        <div className="mt-5 grid grid-cols-1 md:grid-cols-3 gap-4">
          {siteInfo.services.map((service) => (
            <div
              key={service.title}
              className="rounded-lg border border-background-200 bg-background-50 p-6"
            >
              <span className="w-11 h-11 rounded-md bg-primary-600 text-background-50 flex items-center justify-center">
                <i className={`${service.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 text-lg font-bold text-foreground-950">{service.title}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </section>

      <section className="mt-10 grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
          <h2 className="text-lg font-bold text-foreground-950 flex items-center gap-2 mb-5">
            <i className="ri-contacts-line text-primary-600"></i>
            联系方式
          </h2>
          <ul className="space-y-4">
            <li className="flex items-start gap-3">
              <span className="w-9 h-9 rounded-md bg-primary-50 text-primary-600 flex items-center justify-center shrink-0">
                <i className="ri-mail-line"></i>
              </span>
              <div>
                <p className="text-xs text-foreground-500">内容反馈邮箱</p>
                <p className="text-sm font-medium text-foreground-900">
                  {siteInfo.contactEmail}
                </p>
              </div>
            </li>
            <li className="flex items-start gap-3">
              <span className="w-9 h-9 rounded-md bg-primary-50 text-primary-600 flex items-center justify-center shrink-0">
                <i className="ri-briefcase-line"></i>
              </span>
              <div>
                <p className="text-xs text-foreground-500">商务合作邮箱</p>
                <p className="text-sm font-medium text-foreground-900">
                  {siteInfo.cooperationEmail}
                </p>
              </div>
            </li>
            <li className="flex items-start gap-3">
              <span className="w-9 h-9 rounded-md bg-primary-50 text-primary-600 flex items-center justify-center shrink-0">
                <i className="ri-map-pin-line"></i>
              </span>
              <div>
                <p className="text-xs text-foreground-500">办公地点</p>
                <p className="text-sm font-medium text-foreground-900">{siteInfo.address}</p>
              </div>
            </li>
          </ul>
          <p className="mt-5 text-xs text-foreground-400">
            如需反馈内容或商务合作，欢迎通过以上邮箱与我们联系。
          </p>
        </div>

        <div className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
          <h2 className="text-lg font-bold text-foreground-950 flex items-center gap-2 mb-5">
            <i className="ri-earth-line text-primary-600"></i>
            关注我们
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {siteInfo.social.map((s) => (
              <div
                key={s.name}
                className="flex items-center gap-3 rounded-md border border-background-200 bg-background-100 px-4 py-3"
              >
                <span className="w-9 h-9 rounded-md bg-background-50 text-primary-600 flex items-center justify-center">
                  <i className={`${s.icon} text-lg`}></i>
                </span>
                <div>
                  <p className="text-sm font-medium text-foreground-900">{s.name}</p>
                  <p className="text-xs text-foreground-400">搜索“51每日大赛”</p>
                </div>
              </div>
            ))}
          </div>
          <div className="mt-5 rounded-md bg-accent-50 border border-accent-200 p-4">
            <p className="text-xs text-accent-900 flex items-start gap-2">
              <i className="ri-information-line mt-0.5"></i>
              以上联系方式为演示示例，实际信息请以正式上线版本为准。
            </p>
          </div>
        </div>
      </section>

      <section className="mt-10 rounded-lg border border-background-200 bg-background-200/40 p-6 md:p-8">
        <h2 className="text-lg font-bold text-foreground-950 flex items-center gap-2 mb-3">
          <i className="ri-shield-check-line text-primary-600"></i>
          免责声明
        </h2>
        <p className="text-sm text-foreground-600 leading-relaxed">{siteInfo.disclaimer}</p>
        <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
          本站对信息的及时性与准确性尽力维护，但不对因使用本站内容而产生的任何直接或间接损失承担责任。用户在转载或引用本站内容时，请注明来源。
        </p>
        <Link
          to="/"
          className="mt-6 inline-flex items-center gap-1 px-5 py-2.5 rounded-md bg-primary-600 text-background-50 text-sm font-medium hover:bg-primary-700 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-arrow-left-line"></i>
          返回首页
        </Link>
      </section>
    </div>
  );
}